import { Theme } from '@mui/material';

// A dark inner ring inside a white halo, so whichever half loses contrast
// against the backdrop, the other one carries it. See accessibility.md 12.12.
const focusRing = (theme: Theme): string => (
  `0 0 0 2px ${theme.palette.emphasisText.main}, 0 0 0 4px ${theme.palette.background.paper}`
);

export default focusRing;
